define(['underscore', 'backbone', 'jquery', 'assets/js/modules/assets'], function(_, backbone, $, assets) {
    var DEFAULT_MAP_ZOOM = 15;
    var ERROR_TXT_ZIP_NOT_FOUND = 'Location not found. Please enter ZIP code.';
    var ERROR_TXT_ZIP_NOT_FOUND_QUERY_LIMIT = ERROR_TXT_ZIP_NOT_FOUND + ' Limit Exceeded requests.';
    var MARKER_TXT_HERE = "You're here";
    var MARKER_LOGO_SRC = 'logo_32.png';

    var GoogleMap = function(elementId, widgetOptions, mapOptions) {
        this.widgetOptions = {
            linkToLargerMap: true
        };
        this.mapOptions = {
            zoom: 12,
            maxZoom: 12,
            minZoom: 12,
            draggable: false,
            zoomControl: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
            keyboardShortcuts: false,
            center: { lat: 0, lng: 0 },
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        $.extend(this.mapOptions, mapOptions);
        $.extend(this.widgetOptions, widgetOptions);

        this.$el = $('#' + elementId);

        this.map = new google.maps.Map(this.$el.get(0), this.mapOptions);
        this.markers = [];
        this.youAreHereMarker = null;
        this.balloons = [];
        this.$zipInput = null;
        this.geocoder = new google.maps.Geocoder();
        this.geocoderInProgress = false;
        this.geoComplete = null;
        this.mapBounds = null;

        this.address = null;
        this.location = null;

        _.extend(this, backbone.Events);
    };

    GoogleMap.prototype = {
        locate: function(address, markerTitle) {
            var _this = this;

            if (!this.geocoder) {
                console.log('Failed to initialize map');
                return;
            }

            this.geocoder.geocode({ address: address }, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
                        _this.address = address;
                        _this.location = results[0].geometry.location;
                        _this.map.setCenter(_this.location);
                        _this.removeAllMarkers();
                        if (markerTitle) {
                            _this.markers.push(_this.addMarker(_this.location, markerTitle, true));
                        }
                        if (_this.widgetOptions.linkToLargerMap) {
                            _this.addLinkToLargeMap();
                        }
                    } else {
                        console.log('Location not found');
                    }
                } else {
                    console.log('Geocode failed for the following reason: ' + status);
                }
            });
        },

        addMarker: function(location, title, customIcon) {
            return new google.maps.Marker({
                position: location,
                map: this.map,
                title: title,
                icon: this.getIcon(customIcon)
            });
        },

        setMarker: function(id, location, customIcon) {
            this.markers[id] = new google.maps.Marker({
                map: this.map,
                position: new google.maps.LatLng(location['lat'], location['lng']),
                icon: this.getIcon(customIcon)
            });
        },

        handleHereMarker: function(location) {
            if (this.youAreHereMarker === null) {
                this.youAreHereMarker = this.addMarker(location, MARKER_TXT_HERE, false);
            } else {
                this.youAreHereMarker.setPosition(location);
            }
        },

        getMarker: function(id) {
            return this.markers[id];
        },

        getIcon: function(isCustomIcon) {
            if (isCustomIcon) {
                return assets.generateImageUrlForCurrentTheme(MARKER_LOGO_SRC);
            }

            return null;
        },

        addLinkToLargeMap: function() {
            var $link = this.$el.parent('.link-to-large-map');
            if (!$link.length) {
                var isNew = true;
                $link = $('<a class="link-to-large-map" target="_blank">');
            }
            $link.attr('href', 'https://www.google.com/maps/place/' + encodeURIComponent(this.address));
            if (isNew) {
                this.$el.wrap($link);
            }
        },

        removeAllMarkers: function() {
            $.each(this.markers, function(i, marker) {
                marker.setMap(null);
            });
            this.markers = [];
        },

        // builds up zipcode input box event listeners for data entry changes and per keystroke
        initGeoComplete: function($zipInput) {
            var _this = this;
            this.$zipInput = $zipInput;
            _this.triggerGeoComplete();

            // listeners to follow through with completion handler
            this.$zipInput.on('change keydown', function(e) {
                // enter key code is 13
                if (e.which === 13) {
                    return;
                }
                _this.triggerGeoComplete();
            });
        },

        triggerGeoComplete: function() {
            var _this = this;
            var value = _this.$zipInput.val();

            if (!isNaN(value)) {
                google.maps.event.removeListener(_this.geoCompleteListener);
                google.maps.event.clearInstanceListeners(_this.$zipInput.get(0));
                // clear results
                $('.pac-container').remove();
                _this.geoComplete = null;
                _this.geoCompleteListener = null;
                _this.$zipInput.attr('maxlength', 10);
            } else if (_this.geoComplete === null) {
                _this.runGeoComplete();
            }
        },

        runGeoComplete: function() {
            var _this = this;
            var country = this.$zipInput.data('country') || 'US';
            this.$zipInput.removeAttr('maxlength');
            var options = {
                componentRestrictions: {
                    country: country
                }
            };
            _this.geoComplete = new google.maps.places.Autocomplete(_this.$zipInput.get(0), options);
            _this.geoCompleteListener = _this.geoComplete.addListener('place_changed', function() {
                _this.handleGeoComplete();
            });
        },

        handleGeoComplete: function() {
            if (this.geocoderInProgress) {
                return;
            }

            try {
                var place = this.geoComplete.getPlace();
                var location = this.getLocation(place);
                this.handleHereMarker(location.latlng);

                if (location.zip) {
                    this.trigger('GoogleMap:locationFound', location.zip);
                } else if (location.locality) {
                    this.geoCode(location.latlng, true);
                } else if (place.name) {
                    this.geoCodeAddress(place.name);
                } else {
                    this.emitError(ERROR_TXT_ZIP_NOT_FOUND);
                }
            } catch (e) {
                this.emitError(ERROR_TXT_ZIP_NOT_FOUND);
            }
        },

        getLocation: function(place) {
            var _this = this;
            var location = { zip: null, locality: null, latlng: null };

            $.each(place.address_components, function(i, component) {
                if (_this.getZipComponent(component)) {
                    location.zip = _this.getZipComponent(component);
                }
                if (_this.getLocalityComponent(component)) {
                    location.locality = _this.getLocalityComponent(component);
                }
            });

            if (place.geometry && place.geometry.location) {
                location.latlng = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };
            }

            return location;
        },

        getZipComponent: function(component) {
            if (component.types[0] == 'postal_code') {
                return component.long_name;
            }

            return null;
        },

        getLocalityComponent: function(component) {
            if (component.types[0] == 'locality') {
                return component.long_name;
            }

            return null;
        },

        geoCode: function(latlng) {
            var _this = this;
            this.geocoderInProgress = true;
            this.geocoder.geocode({ location: latlng }, function(results, status) {
                _this.geocoderInProgress = false;
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    var location = _this.handleGeoResult(results[0], false);

                    if (!location || location.zip === null) {
                        _this.emitError(ERROR_TXT_ZIP_NOT_FOUND);
                    }
                } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                    _this.emitError(ERROR_TXT_ZIP_NOT_FOUND_QUERY_LIMIT);
                } else {
                    _this.emitError(ERROR_TXT_ZIP_NOT_FOUND);
                }
            });
        },

        geoCodeAddress: function(address) {
            var _this = this;
            this.geocoderInProgress = true;

            //if we have 9-digit zip - it should be transformed to acceptable format xxxxx-xxxx
            if (!isNaN(address) && address.length === 9) {
                address = address.slice(0, 5) + '-' + address.slice(5);
            }
            this.geocoder.geocode({ address: address }, function(results, status) {
                _this.geocoderInProgress = false;
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    var location = _this.handleGeoResult(results[0], true);
                    if (location.zip === null) {
                        _this.geoCode(location.location, false);
                    }
                } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                    _this.emitError(ERROR_TXT_ZIP_NOT_FOUND_QUERY_LIMIT);
                } else {
                    _this.emitError(ERROR_TXT_ZIP_NOT_FOUND);
                }
            });
        },

        /**
         * @param {string} err
         */
        emitError: function(err) {
            this.trigger('GoogleMap:error', err);
        },

        /**
         * @param {Object} result
         * @param {boolean} placeHereMarker
         * @returns {Object}
         */
        handleGeoResult: function(result, placeHereMarker) {
            var _this = this;
            var object = { zip: null, location: null };
            object.location = {
                lat: result.geometry.location.lat(),
                lng: result.geometry.location.lng()
            };

            if (placeHereMarker) {
                _this.handleHereMarker(object.location);
            }

            $.each(result.address_components, function(i, component) {
                if (_this.getZipComponent(component)) {
                    object.zip = _this.getZipComponent(component);
                    _this.trigger('GoogleMap:locationFound', object.zip);

                    return object;
                }
            });

            return object;
        },

        handleClickPickupLocation: function(marker, text, target, val) {
            var _this = this;
            marker.addListener('click', function() {
                _this.clearAllInfoWindow();
                var balloon = new google.maps.InfoWindow({
                    content: text
                });
                _this.balloons.push(balloon);

                balloon.open(marker.get('map'), marker);
                _this.selectValue(target, val);
                _this.zoomMap(marker.getPosition());
            });
        },

        fitMap: function() {
            var _this = this;
            _this.clearAllInfoWindow();
            this.$el.show();

            _this.mapBounds = new google.maps.LatLngBounds();
            for (var location in _this.markers) {
                if (_this.markers.hasOwnProperty(location)) {
                    _this.mapBounds.extend(_this.markers[location].getPosition());
                }
            }
            if (_this.youAreHereMarker) {
                _this.mapBounds.extend(_this.youAreHereMarker.getPosition());
            }

            _this.fitBounds(_this.mapBounds);
            google.maps.event.trigger(_this.map, 'resize');
        },

        zoomMap: function(location) {
            var _this = this;
            var bounds = new google.maps.LatLngBounds();
            bounds.extend(location);
            _this.fitBounds(bounds);
        },

        fitBounds: function(bounds) {
            var _this = this;
            _this.map.setOptions({ maxZoom: DEFAULT_MAP_ZOOM });
            _this.map.fitBounds(bounds);
            _this.map.setOptions({ maxZoom: null });
        },

        clearMap: function() {
            var _this = this;
            _this.$el.hide();
            for (var location in _this.markers) {
                if (_this.markers.hasOwnProperty(location)) {
                    _this.markers[location].setMap(null);
                }
            }
            _this.clearAllInfoWindow();
            _this.markers = [];
            _this.mapBounds = null;
        },

        clearAllInfoWindow: function() {
            for (var balloon in this.balloons) {
                if (this.balloons.hasOwnProperty(balloon)) {
                    this.clearInfoWindow(this.balloons[balloon]);
                }
            }
        },

        clearInfoWindow: function(balloon) {
            balloon.setMap(null);
            balloon = null;
        },

        selectValue: function($element, value) {
            var $selectBox = $element.data('selectBox-selectBoxIt');
            if ($selectBox) {
                $element.val(value);
                $selectBox.refresh();
                $element.trigger('change');
            } else {
                $('[data-location-id="' + value + '"]')
                    .first()
                    .click();
            }
        }
    };

    return new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = '//maps.googleapis.com/maps/api/js?key=' + ONP.config.googleAPIKey + '&sensor=false&libraries=places';
        document.body.appendChild(script);
        script.onload = function() {
            resolve(GoogleMap);
        };
        script.onerror = function() {
            reject('Error loading google map script');
        };
    });
});
